<template lang="html">
    <div id="hamberger-menu" class="nav-icon"
        :class="{
            'back': back
            }"
    >
        <div class="nav-icon-bars">
            <span></span>
            <span></span>
            <span></span>
        </div>

    </div>

</template>

<script>
export default {
    props: {
        back: Boolean
    }
}
</script>

<style lang="less">
.nav-icon {
    position: relative;
    cursor: pointer;
    .nav-icon-bars {
        height: 21px;
        width: 25px;
        position: relative;
        margin: 20px auto;
    }
    span {
        display: block;
        height: 3px;
        width: 26px;
        background: #fff;
        border-radius: 1px;
        opacity: 1;
        transform: rotate(0deg);
        transition: opacity 0.3s, transform 0.3s ease-in-out;
        margin: 6px 0;
        transform-origin: left center;
    }
}

.nav-icon.open span:nth-child(1) {
    transform: rotate(45deg);
}

.nav-icon.open span:nth-child(2) {
    transform: scaleX(0);
    opacity: 0.01;
}

.nav-icon.open span:nth-child(3) {
    transform: rotate(-45deg);
}

.nav-icon.back span:nth-child(1) {
    transform: rotate(45deg) translate3d(5px, 5px, 0) scaleX(0.7);
}

.nav-icon.back span:nth-child(2) {
    transform: scaleX(0);
    opacity: 0.01;
}

.nav-icon.back span:nth-child(3) {
    transform: rotate(-45deg) translate3d(7px, -7px, 0) scaleX(0.7);
}
</style>



// WEBPACK FOOTER //
// HamburgerIcon.vue?d31acf46